export function formatPoints(n) {
    if (n == null) return "0";
    if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
    if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(1) + "K";
    return new Intl.NumberFormat("es-ES").format(Math.round(n));
}

export function timeLeft(iso, lang = "es") {
    if (!iso) return "—";
    const target = new Date(iso).getTime();
    const now = Date.now();
    const ms = target - now;
    if (ms <= 0) return lang === "es" ? "cerrado" : "closed";
    const m = Math.floor(ms / 60000);
    const d = Math.floor(m / (60 * 24));
    const h = Math.floor((m % (60 * 24)) / 60);
    const mins = m % 60;
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${mins}m`;
    return `${mins}m`;
}
